
interface OperationOptions {
  annual_interest_rate: string | number
  loan_period_years: string | number
  listing_price: string | number
  loan_amount_ratio: string | number
  future_value?: string | number
  payment_due_at_period_start?: boolean
}

class Operation {
  private readonly annual_interest_rate: number
  private readonly loan_period_years: number
  private readonly listing_price: number
  private readonly loan_amount_ratio: number
  // not used in hk
  private readonly future_value = 0 as number
  private readonly payment_due_at_period_start: boolean

  constructor(options: OperationOptions){
    this.annual_interest_rate = parseFloat(options.annual_interest_rate.toString())
    this.loan_period_years = parseFloat(options.loan_period_years.toString())
    this.listing_price = parseFloat(options.listing_price.toString())
    this.loan_amount_ratio = parseFloat(options.loan_amount_ratio.toString())
    if (options.future_value != null) {
      this.future_value = parseFloat(options.future_value.toString())
    }
    this.payment_due_at_period_start = (options.payment_due_at_period_start === true)
  }

  public call(){
    return {
      result: this.calculate(),
    }
  }

  public calculate(){
    const monthly_interest_rate_ratio = this.monthly_interest_rate_ratio()
    const loan_period_months = this.loan_period_months()
    const present_value = this.present_value()

    const future_value = this.future_value
    const payment_due_at_period_start = this.payment_due_at_period_start

    if (monthly_interest_rate_ratio === 0) {
      return -(present_value + future_value) / loan_period_months
    }

    const pvif = Math.pow(1 + monthly_interest_rate_ratio, loan_period_months)
    let pmt = monthly_interest_rate_ratio / (pvif - 1) * -(present_value * pvif + future_value)

    if (payment_due_at_period_start) {
      pmt /= (1 + monthly_interest_rate_ratio)
    }

    return pmt
  }

  private monthly_interest_rate_ratio(){
    return (this.annual_interest_rate / 12.0) / 100.0
  }

  private loan_period_months(){
    return (this.loan_period_years * 12.0)
  }

  private loan_amount(){
    return (this.listing_price * (this.loan_amount_ratio / 100.0))
  }

  private present_value(){
    return this.loan_amount()
  }
}


export default Operation
